import { render, staticRenderFns } from "./addgreet.vue?vue&type=template&id=fe043306"
import script from "./addgreet.vue?vue&type=script&lang=js"
export * from "./addgreet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports